export default __webpack_public_path__ + "app/images/theme-images/dark/ic-24-arrow-right.svg";